import { render, staticRenderFns } from "./show_manipulated_order_fields.vue?vue&type=template&id=e8e084b6&lang=pug&"
import script from "./show_manipulated_order_fields.vue?vue&type=script&lang=js&"
export * from "./show_manipulated_order_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports